
import { defineComponent, computed } from "vue";
import KTNotificationsMenu from "@/layout/header/partials/NotificationsMenu.vue";
import KTQuickLinksMenu from "@/layout/header/partials/QuickLinksMenu.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";

export default defineComponent({
  name: "topbar",
  components: {
    KTNotificationsMenu,
    KTQuickLinksMenu,
    KTUserMenu,
  },
  setup() {
    const name = JSON.parse(localStorage.getItem("user_account")!).name; 
    const email = JSON.parse(localStorage.getItem("user_account")!).email;

    return {
      name,
      email,
    };
  }

});
